import ringAlert from '@jetbrains/ring-ui/dist/alert-service/alert-service.js';
import styles from './alert.module.css.js';

var AlertType;
(function (AlertType) {
  AlertType["ERROR"] = "error";
  AlertType["MESSAGE"] = "message";
  AlertType["SUCCESS"] = "success";
  AlertType["WARNING"] = "warning";
  AlertType["LOADING"] = "loading";
})(AlertType || (AlertType = {}));
var DEFAULT_TIMEOUT = undefined;
var alert = function alert(message, type, options) {
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_TIMEOUT;
  ringAlert.addAlert(message, type, timeout, options);
};
var showError = function showError(message) {
  alert(message, AlertType.ERROR, {
    className: styles.error
  });
};
var showMessage = function showMessage(message) {
  alert(message, AlertType.MESSAGE, {
    className: styles.message
  });
};
var showWarning = function showWarning(message) {
  alert(message, AlertType.WARNING, {
    className: styles.warning
  });
};
var showSuccess = function showSuccess(message) {
  alert(message, AlertType.SUCCESS, {
    className: styles.success
  });
};
var showLoading = function showLoading(message) {
  alert(message, AlertType.LOADING, {
    className: styles.loading
  });
};

export { showError, showLoading, showMessage, showSuccess, showWarning };
